import React, {useState} from "react"
import QuestaoSingle from "../components/questaosingle"
import Resumo from "../components/resumo"
import IndicadorQuestao from "./indicadorquestao";
import NumberFormat from 'react-number-format';

var allQuestions = [];
var answers = [];


const renderquestao = (questoes, icone, updateQuestion, currentQuestion, changeQuestion, service, selectedAnswer) =>{
  let nrquestaoatual = parseInt(currentQuestion)+1; 
  
return (
  <>
              <style>{
    `#background{
      transform:  rotate(var(--esq));
    }
    
    @media only screen and (max-width: 450px) {
      #background{
        transform: rotate(10deg) scale(1.1) translateX(20%);
      }
      .line{
        display: none;
      }
      .toplogo img{
        margin: 6% auto 6%;
        width: 24%;
      }
    }
  }    
  
    `}
  </style>
  <div className="">
  <div className="indicadorHolder">
      <IndicadorQuestao atual={nrquestaoatual} questoes={questoes}></IndicadorQuestao>
    </div>
    <span className="serviceTitle" style={{marginTop:"0px"}}>Quanto poderá custar <span className="service">{service}</span></span>
    <div className="serviceSubtitle">Para isso responda às seguintes questões</div>
    
    <div style={{maxWidth: "650px", margin: "auto"}}>
      <div className="">
        <QuestaoSingle questao={questoes[parseInt(currentQuestion)]} nrQuestao={nrquestaoatual} updateQuestion={updateQuestion} selectedAnswer={selectedAnswer.Selected} className="uk-link-reset">
        </QuestaoSingle>
      </div>
    
      <div>
          <div className="contadorParent uk-align-center">
            {/* <div style={{color:"white"}}>Questão {currentQuestion + 1}/{questoes.length}</div> */}
            <div className="contador">
              <div className="uk-column-1-2 uk-column-divider divider">
                <div className="contadorTexto">Orçamento estimado até ao momento</div>
                <div className="custo">
                <NumberFormat value={answers.map(x => x.Cost).reduce((i1,i2) => i1+i2,0)} className="foo" displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} suffix={' €'} renderText={(value, props) => <div {...props}>{value}</div>} />
                  </div>
            </div>
            <div className="notDivider" >
              <div style={{margin:"auto 17% auto 7%"}}>
                <img style={{filter: "brightness(0) invert(1)"}} src={icone}/></div>              
              <div className="custo">
              <NumberFormat value={answers.map(x => x.Cost).reduce((i1,i2) => i1+i2,0)} className="foo" displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} suffix={' €'} renderText={(value, props) => <div {...props}>{value}</div>} />
                <div style={{fontSize:"12px"}}>* orçamento estimado</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="uk-column-1-2 uk-column-divider pag">
      <div className={'button'+ (currentQuestion ==0 ? ' disabled' : '')} onClick={() => {if(!currentQuestion ==0){changeQuestion(currentQuestion-1, "prev")}else{window.location.href ="/"}}}>Anterior</div>
      <div className={"button bold"+ (!selectedAnswer.Selected ? " disabled" : "")} onClick={() => { changeQuestion(currentQuestion+1, "next")}}>Próximo</div>
    </div>
  </div>

  <style>
    {
      `
      `
    }
  </style>
  </>
)}


const Questao = ({ questoes, icone ,iconeBusiness, contactoTitulo, contactoDescricao, service}) => {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  var backToFirst = () => setCurrentQuestion(0);

  var changeQuestion = (position, button) => {
    //Se a questão estiver respondida - Avança
    if(button === "next"){
      questoes.map(x =>{
        if(currentQuestion+1 == x.id){
          if(x.Respostas.some(m => m.Selected === true)){            
            setCurrentQuestion(position);      
       }
        }
      })
    }
    if(button === "prev"){
      setCurrentQuestion(position);
    }

  }

  var updateQuestion = (answer) =>{
    // answers[currentQuestion] = answer;  
    //Coloca todas as answers.Selected a false da respetiva questão
    questoes.map(x =>{
    
      if(currentQuestion+1 == x.id){
        x.Respostas.map(m =>{
         m.Selected = false;
        })
      }
    })
    //coloca true na answer.Selected da questão selecionada
    answer.Selected = true;

    //Rotação do background consoante a posição atual do mesmo
    let background = document.getElementById('background');
    var st = window.getComputedStyle(background, null);
    var rotateBackground = st.getPropertyValue("transform") || "none";
    
    if( rotateBackground !== "none") {
      var values = rotateBackground.split('(')[1];
        values = values.split(')')[0];
        values = values.split(',');
      var a = values[0];
      var b = values[1];
      var c = values[2];
      var d = values[3];

      var radians = Math.atan2(b, a);
      if ( radians < 0 ) {
        radians += (2 * Math.PI);
      }
      var angle = Math.round( radians * (180/Math.PI));
     
      if(window.innerWidth < 450){
        angle += 5;
        background.style.transform = "rotate("+angle+"deg) scale(1.1) translateX(20%)"; 
      }else{
        angle += 30;
        background.style.transform = "rotate("+angle+"deg)"; 
      }
      
    } 

    answers[currentQuestion] = answer;  
     
     
    if(currentQuestion+1 <= questoes.length){   
    // se for antes da última passa para próxima
    setCurrentQuestion( currentQuestion + 1);

    }
    // setCurrentValue(currentValue + answer.Cost); //somava valor, agora calculamos answers.map(x => x.Cost)
    
  }
  allQuestions = questoes;
  console.log("Answers:");
  console.log(answers);
  console.log("Questions:");
  console.log(questoes);
  if(currentQuestion+1 <=  questoes.length){
    // se não tiver todas as respostas, render pergunta
    return(renderquestao(questoes, icone, updateQuestion, currentQuestion, changeQuestion, service, answers[currentQuestion] || false));
  }
  else
  {
    // se tiver passa para o Resumo
    return (
    <Resumo questoes={questoes} respostas={answers} contactoTitulo={contactoTitulo} contactoDescricao={contactoDescricao} backToQuestions={backToFirst} icone={icone} iconeBusiness={iconeBusiness} service={service}></Resumo>
    )
  }
}
export default Questao